import { render, staticRenderFns } from "./PaymentFaq.vue?vue&type=template&id=55566c69&scoped=true"
import script from "./PaymentFaq.vue?vue&type=script&lang=js"
export * from "./PaymentFaq.vue?vue&type=script&lang=js"
import style0 from "./PaymentFaq.vue?vue&type=style&index=0&id=55566c69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55566c69",
  null
  
)

export default component.exports